/**
 * Clipboard hook for copying text to clipboard
 * Follows LiveView best practices - browser API wrapper only
 */
const Clipboard = {
  mounted() {
    // Handle copy to clipboard - pure browser API wrapper
    this.handleEvent('copy_to_clipboard', ({ text }) => {
      navigator.clipboard.writeText(text).then(() => {
        this.pushEvent('flash', { type: 'info', message: 'Copied to clipboard' });
      }).catch((_err) => {
        this.pushEvent('flash', { type: 'error', message: 'Failed to copy' });
      });
    });

    // Handle populate input - this is acceptable as it's responding to a server command
    // The server decides WHEN to populate, hook just executes the browser API
    this.handleEvent('populate_input', ({ text }) => {
      // Find the input within this hook's scope (the main container)
      const input = this.el.querySelector('#message-input');
      if (input) {
        // Use textContent for contenteditable elements, value for regular inputs
        if (input.contentEditable === 'true') {
          input.textContent = text;
        } else {
          input.value = text;
        }
        input.focus();
        // Trigger auto-expand if hook exists
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
};

export default Clipboard;
